import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';

// Project-imports
import { fetcher } from 'utils/axios';

// types
import { MenuProps } from 'types/menu';
import { NavItemType } from 'types';

const initialState: MenuProps = {
  isDashboardDrawerOpened: false
};

const endpoints = {
  key: 'api/menu',
  master: 'master',
  widget: '/widget' // server URL
};

/*export function useGetMenu() {
  const { data, isLoading, error, isValidating } = useSWR(endpoints.key + endpoints.widget, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menu: data?.widget as NavItemType,
      menuLoading: isLoading,
      menuError: error,
      menuValidating: isValidating,
      menuEmpty: !isLoading && !data?.length
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}*/


export const staticMenu: NavItemType = {
  id: 'navigation',
  type: 'group',
  title: 'Menú',
  children: [    
    {
      id: 'administrativeTools',
      title: 'Administrative Tools',
      type: 'collapse',
      children: [
        {
          id: 'administrativeToolsOverview',
          title: 'Overview',
          type: 'item',
          url: '/administrative-tools',
          link: '/administrative-tools'
        },
        {
          id: 'locations',
          title: 'Locations',
          type: 'item',
          url: '/administrative-tools/locations',
          link: '/administrative-tools/locations'
        },
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/administrative-tools/users',
          link: '/administrative-tools/users'
        },
        {
          id: 'doctors',
          title: 'Doctors',
          type: 'item',
          url: '/administrative-tools/doctors',
          link: '/administrative-tools/doctors'
        },
        {
          id: 'searchRecords',
          title: 'Search Records',
          type: 'item',
          url: '/administrative-tools/search',
          link: '/administrative-tools/search'
        },
        {
          id: 'statistics',
          title: 'Statistics',
          type: 'item',
          url: '/administrative-tools/statistics',
          link: '/administrative-tools/statistics'
        }
      ]
    }
  ]
};


export function useGetMenu() {
  const memoizedValue = useMemo(
    () => ({
      menu: staticMenu,  
      menuLoading: false,
      menuError: null,
      menuValidating: false,
      menuEmpty: false
    }),
    []
  );

  return memoizedValue;
}

export function useGetMenuMaster() {
  const { data, isLoading } = useSWR(endpoints.key + endpoints.master, () => initialState, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });

  const memoizedValue = useMemo(
    () => ({
      menuMaster: data as MenuProps,
      menuMasterLoading: isLoading
    }),
    [data, isLoading]
  );

  return memoizedValue;
}

export function handlerDrawerOpen(isDashboardDrawerOpened: boolean) {
  // to update local state based on key

  mutate(
    endpoints.key + endpoints.master,
    (currentMenuMaster: any) => {
      return { ...currentMenuMaster, isDashboardDrawerOpened };
    },
    false
  );
}
